<template>
  <DrawerRoot v-slot="slotProps" v-bind="forwarded">
    <slot v-bind="slotProps" />
  </DrawerRoot>
</template>

<script setup>
defineOptions({ name: 'UiDrawer' });
import { DrawerRoot, useForwardPropsEmits } from 'reka-ui';

const props = defineProps({
  open: { default: undefined, type: Boolean, required: false },
  defaultOpen: { default: undefined, type: Boolean, required: false },
  modal: { default: undefined, type: [Boolean, String], required: false },
  swipeDirection: { default: undefined, type: String, required: false },
  snapPoints: { default: undefined, type: Array, required: false },
  snapPoint: { default: undefined, type: [Number, String, null], required: false },
  defaultSnapPoint: { default: undefined, type: [Number, String, null], required: false },
  snapToSequentialPoints: { default: undefined, type: Boolean, required: false },
});

const emits = defineEmits(['update:open', 'update:openComplete', 'update:snapPoint']);

const forwarded = useForwardPropsEmits(props, emits);
</script>
